module.exports = __webpack_public_path__ + "img/28.e81f1560.png";